export default __webpack_public_path__ + "assets/images/9fcdb4f0104d89ad520659d5c9ebe8ad.svg";